module.exports = __webpack_public_path__ + "img/bomba_zmix.646ecff9.jpg";